import { AgGridReact } from "ag-grid-react";
import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback,
} from "react";
import { useNavigate } from "react-router-dom";
import "ag-grid-community/styles/ag-theme-alpine.css";
import axios from "axios";
import API_BASE_URL from "../config";
import ProfilePictureRenderer from "../components/ProfilePictureRenderer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function SurveySetup() {
  let navNaigate = useNavigate();
  const [usergrid, setUserGrid] = useState([]);
  const [participantlist, setParticipantList] = useState();
  const [participantcount, setParticipantCount] = useState(0);
  const gridRef = useRef();
  const [rowData, setRowData] = useState();
  const [surveyparticipantlist, setSurveyParticipantList] = useState({
    surv_id: JSON.parse(sessionStorage.getItem("new_survey")).surv_id,
    created_by: JSON.parse(sessionStorage.getItem("user_credential")).user_name,
  });
  const [survey, setSurvey] = useState(
    JSON.parse(sessionStorage.getItem("new_survey"))
  );
  const handlenavigate = (path) => {
    navNaigate(path);
  };
  const [reqErrMsg, setReqErrMsg] = useState({});

  const [saveSuccess, setSaveSuccess] = useState(false);

  useEffect(() => {
    const getAllUsers = async () => {
      const resUsers = await fetch(`${API_BASE_URL}GetAllUsersList.php/`);
      const resuserjson = await resUsers.json();
      setRowData(await resuserjson.data);
    };
    getAllUsers();
  }, []);

  useEffect(() => {
    const getSurveyUsers = async () => {
      const resSurvUsers = await fetch(
        `${API_BASE_URL}GetAllSurveyUsers.php/${
          JSON.parse(sessionStorage.getItem("new_survey")).surv_id
        }`
      );
      const ressurveyuserjson = await resSurvUsers.json();
      setSurveyParticipantList(await ressurveyuserjson.data);
      //console.log(ressurveyuserjson.data);
    };
    getSurveyUsers();
  }, []);

  /*  useEffect(() => {
    const getSurveyById = async () => {
      const resSurv = await fetch(
        `${API_BASE_URL}GetSurveyById.php/${
          JSON.parse(sessionStorage.getItem("new_survey")).surv_id
        }`
      );
      const ressurveyjson = await resSurv.json();
      console.log(JSON.stringify(ressurveyjson));
      //sessionStorage.setItem("new_survey", JSON.stringify(ressurveyjson.data));
    };
    getSurveyById();
  }, [saveSuccess]);*/

  useEffect(() => {
    const getAllSurvey = async () => {
      const resAllSurvey = await fetch(
        `${API_BASE_URL}GetAllSurvey.php/${
          JSON.parse(sessionStorage.getItem("new_survey")).surv_id
        }`
      );
      const resallsurvey = await resAllSurvey.json();
      sessionStorage.setItem(
        "new_survey",
        JSON.stringify(resallsurvey.data[0])
      );
      setSurvey(resallsurvey.data[0]);
      //setSurveyList(await resallsurvey.data);
    };
    getAllSurvey();
  }, [saveSuccess]);

  const onSelectionChanged = useCallback(() => {
    var selectedRows = gridRef.current.api.getSelectedRows();
    var selectedRowsString = "";
    selectedRows.forEach(function (selectedRow, index) {
      if (index > 0) {
        selectedRowsString += "|#|";
      }
      selectedRowsString += selectedRow.user_name;
    });
    setParticipantList(selectedRowsString);
    setSurveyParticipantList({
      ...surveyparticipantlist,
      participants: selectedRowsString,
    });
  }, []);

  const [userColsDef, setUserColsDef] = useState([
    {
      field: "user_name",
      headerCheckboxSelection: true,
      checkboxSelection: true,
      showDisabledCheckboxes: true,
      headerName: "",
      cellRenderer: () => <div>&nbsp;</div>,
      width: 50,
    },
    {
      headerName: "",
      field: "prof_pic_path",
      width: 100,
      cellStyle: { textAlign: "center" },
      cellRenderer: ProfilePictureRenderer,
      filter: false,
    },
    {
      field: "title",
      width: 80,
      headerName: "Title",
    },
    {
      field: "f_name",
      width: 150,
      headerName: "Name",
    },
    {
      field: "l_name",
      width: 150,
      headerName: "Last Name",
    },
    {
      field: "desig_name",
      width: 150,
      headerName: "Designation",
    },
    {
      field: "mobile_num",
      width: 120,
      headerName: "Mobile",
    },
  ]);

  const defaultColDef = useMemo(() => ({
    filter: true, // Enable filtering on all columns
  }));

  const handlepublish = () => {
    //console.log(surveyparticipantlist);
    if (validateSurvey()) {
      if (window.confirm("Are you sure, You want to Publish the survey?")) {
        SaveParticipants(1);
      }
    }
  };

  const validateSurvey = () => {
    let isSuccess = true;
    const req_error = {};

    //const new_field_error = {};
    if (!survey.surv_name || survey.surv_name === "") {
      req_error.surv_name = "Required";
      isSuccess = false;
    }

    /*if (!surveyparticipantlist || surveyparticipantlist === "") {
      req_error.surveyparticipantlist = "Required";
      isSuccess = false;
    }*/
    //Set is_pubish flag to true
    /*if (isSuccess === true) {
      console.log(isSuccess);
      setSurvey((prevSurvey) => ({ ...prevSurvey, is_publish: 1 }));
    }*/
    //console.log(isSuccess);
    setReqErrMsg(req_error);
    return isSuccess;
  };

  const SaveParticipants = async (is_publish) => {
    const formfldData = new FormData();
    formfldData.append("survey", JSON.stringify(survey));
    formfldData.append(
      "surveyparticipantlist",
      JSON.stringify(surveyparticipantlist)
    );
    formfldData.append("is_publish", is_publish);
    formfldData.append(
      "created_by",
      JSON.parse(sessionStorage.getItem("user_credential")).user_name
    );
    const templsaver = await axios
      .post(`${API_BASE_URL}InsertSurveyParticipants.php`, formfldData, {
        hearders: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        //handlenavigate("/survey");
        setSaveSuccess(true);
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  };
  const handleCopyToClipboard = () => {
    const copyPath =
      process.env.REACT_APP_SURVEY_URL +
      "?su=" +
      JSON.parse(sessionStorage.getItem("new_survey")).surv_uuid;

    navigator.clipboard.writeText(copyPath);
  };

  return (
    <>
      <div className="col-xl-6 mx-auto">
        <div className="row">
          <div className="col-md-4">
            <button
              className="btn btn-primary disabled btn-circle"
              id="btn_share_link"
              style={{ cursor: "pointer" }}
              onClick={() => handlenavigate("/surveyadd")}
              title="Create desired user input fields for your customize survey form"              
            >
              1
            </button>
            &nbsp;&nbsp;
            <a
              className="mt-2"
              style={{ cursor: "pointer" }}
              onClick={() => handlenavigate("/surveyadd")}
            >
              Design
            </a>
          </div>
          <div className="col-md-4">
            <button
              className="btn btn-primary btn-circle"
              id="btn_share_link"
              style={{ cursor: "pointer" }}
              onClick={() => handlenavigate("/surveysetup")}
              title="Choose users for your survey form or share survey link to specific participants"
            >
              2
            </button>
            &nbsp;&nbsp;
            <a
              class="mt-2"
              style={{ cursor: "pointer" }}
              onClick={() => handlenavigate("/surveysetup")}
            >
              Setup
            </a>
          </div>
          <div className="col-md-4">
            <button
              className="btn btn-primary disabled btn-circle"
              id="btn_share_link"
              style={{ cursor: "pointer" }}
              onClick={() => handlenavigate("/surveyanalyze")}
              title="Analyze and access participants input and generate reports"              
            >
              3
            </button>
            &nbsp;&nbsp;
            <a
              class="mt-2"
              style={{ cursor: "pointer" }}
              onClick={() => handlenavigate("/surveyanalyze")}
            >
              Analyze
            </a>
          </div>
        </div>
        <hr />
        <h3>
          {sessionStorage.getItem("new_survey")
            ? JSON.parse(sessionStorage.getItem("new_survey")).surv_name
            : ""}
        </h3>
        <div>&nbsp;</div>
        <div class="card shadow mb-4">
          <div className="card-body">
            <div className="row">
              <div className="col">
                <label className="small mb-1" for="inputSurvName">
                  <i className="text-danger">*</i>Survey Title
                </label>
                <input
                  className="form-control"
                  id="surv_name"
                  type="text"
                  placeholder="Survey Name"
                  value={survey.surv_name}
                  maxLength={120}
                  onChange={(e) =>
                    setSurvey({ ...survey, surv_name: e.target.value })
                  }
                />
                {reqErrMsg.surv_name && (
                  <p className="small mt-1 text-danger">Required</p>
                )}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col">
                <label className="small mb-1" for="inputSurvDesc">
                  Description (Max 200 Characters)
                </label>
                <textarea
                  className="form-control"
                  id="surv_desc"
                  placeholder="Description"
                  value={survey.surv_desc}
                  //style={{width:"700px"}}
                  onChange={(e) =>
                    setSurvey({ ...survey, surv_desc: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col">
                <label className="small mb-1" for="inputSurvDesc">
                  Start Date
                </label>
              </div>
              <div className="col">
                <label className="small mb-1" for="inputSurvDesc">
                  End Date
                </label>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <DatePicker
                  id="date_start"
                  className="form-control"
                  selected={
                    survey.date_start ? new Date(survey.date_start) : null
                  }
                  onChange={(seldate) =>
                    setSurvey({ ...survey, date_start: seldate })
                  }
                />
              </div>
              <div className="col mx-4">
                <DatePicker
                  id="date_end"
                  className="form-control"
                  selected={survey.date_end ? new Date(survey.date_end) : null}
                  onChange={(seldate) =>
                    setSurvey({ ...survey, date_end: seldate })
                  }
                />
              </div>
            </div>
            <div className="row mt-2 mb-3">
              <div className="col-11">
                <label className="small mb-1" for="inputSurvDesc">
                  Survey Link
                </label>
                <input
                  className="form-control"
                  id="surv_link"
                  type="text"
                  value={
                    survey.is_publish === 1
                      ? process.env.REACT_APP_SURVEY_URL +
                        "?su=" +
                        JSON.parse(sessionStorage.getItem("new_survey"))
                          .surv_uuid
                      : ""
                  }
                  readOnly
                />
              </div>
              <div className="col-1 mt-4">
                {(survey.is_publish === 1 && (
                  <button
                    className="btn btn-warning btn-circle"
                    title="Copy Link"
                    onClick={handleCopyToClipboard}
                  >
                    <i className="fas fa-copy"></i>
                  </button>
                )) || (
                  <button
                    className="btn btn-secondary btn-circle"
                    title="Copy Link"
                  >
                    <i className="fas fa-copy"></i>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div></div>
        <div>
          <label className="small mb-1">
            Add Participants (Click on check boxes to add participants from
            below user list)
          </label>
        </div>
        <div className="row">
          <div
            id="user_grid"
            //className="ag-theme-quartz"
            className="ag-theme-quartz"
            style={{
              width: "100%",
              height: 400,
            }}
          >
            <AgGridReact
              ref={gridRef}
              rowData={rowData}
              columnDefs={userColsDef}
              defaultColDef={defaultColDef}
              rowSelection={"multiple"}
              //onGridReady={onGridReady}
              onSelectionChanged={onSelectionChanged}
            />
          </div>
        </div>
        <div>&nbsp;</div>
        <div className="row gx-3 mt-3" style={{ marginLeft: "35%" }}>
          {(parseInt(
            JSON.parse(sessionStorage.getItem("new_survey")).is_publish
          ) !== 1 && (
            <>
              <button
                id="btn_submit"
                className="btn btn-primary align-center"
                type="button"
                data-toggle="modal"
                data-target="#publishModal"
                //onClick={() => handlepublish()}
              >
                &nbsp;&nbsp;Publish&nbsp;&nbsp;
              </button>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button
                id="btn_preview"
                className="btn btn-primary align-center"
                type="button"
                onClick={() => SaveParticipants(0)}
              >
                &nbsp;Save&nbsp;
              </button>
            </>
          )) || (
            <>
              <button
                id="btn_submit"
                className="btn btn-primary align-center"
                type="button"
                disabled
              >
                &nbsp;&nbsp;Publish&nbsp;&nbsp;
              </button>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button
                id="btn_preview"
                className="btn btn-primary align-center"
                type="button"
                disabled
              >
                &nbsp;Save&nbsp;
              </button>
            </>
          )}
        </div>
        <div className="row gx-3 mt-3">&nbsp;</div>
        <div className="row gx-3 mt-3">&nbsp;</div>
      </div>
      <div
        class="modal fade bd-example-modal-lg"
        id="publishModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="publishModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5>
                Are you sure? You want to Publish the survey as following info.
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div className="row gx-8 mx-3">
                Survey Name:&nbsp;
                {survey.surv_name}
                <br />
                Start Date:&nbsp;
                {survey.date_start}
                <br />
                End Date:&nbsp;
                {survey.date_end}
                <br />
                Participants:&nbsp; {participantlist}
              </div>
            </div>
            <div class="modal-footer">
              <button
                id="btn_publish_final"
                className="btn btn-primary align-center"
                type="button"
                onClick={() => handlepublish()}
                data-dismiss="modal"
              >
                &nbsp;&nbsp;Publish&nbsp;&nbsp;
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
